// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"16a352a5","127":"8a36de9e","198":"1cdc66ad","226":"02114db1","293":"43285cd3","594":"44dd3700","645":"3d02a5ea","796":"e40baa0a","978":"aeda5ff7"}[chunkId] + ".chunk.js";
};